import type { App } from 'vue';
import { getCurrency } from '../functions';

export default {
	install: (app: App) => {
		const currency = getCurrency();
		app.config.globalProperties.$currency = currency;
	}
};
